<template>
  <div id="demo-basic-card">

    <div id="addModuleLoadingDiv" class="vs-con-loading__container">
        <vx-card :title="module_data.name" class="mb-base">
            <template   slot="actions">
                <vx-tooltip text="Back to all modules" position="left">
                    <feather-icon @click="redirectToAllModule()" icon="ChevronsLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </vx-tooltip>
            </template>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input v-validate="'required'" name="name" ref="name" class="w-full" label="Module name" v-model="module_data.name" />
                    <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    Type
                    <v-select v-validate="'required'" name="type" ref="type" v-model="moduleType" :options="['Teori','Kørsel','Manøvre','Glatbane','Other']" />
                    <span class="text-danger text-sm" v-show="errors.has('type')">{{ errors.first('type') }}</span>
                </div>
            </div>
            <div class="vx-row" v-if="moduleType == 'Other'">
                <div class="vx-col  w-full mb-4">
                    <vs-input v-validate="'required'" name="other_type" ref="other_type" class="w-full" label="Add module type" v-model="otherModuleType" />
                    <span class="text-danger text-sm" v-show="errors.has('other_type')">{{ errors.first('other_type') }}</span>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-4">
                    <vs-input class="w-full" label="Class Location" v-model="module_data.location" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-4">
                    Duration (Minutes)
                    <v-select label="Name" v-model="module_data.hours" :options="[45, 90, 135, 180, 225, 270, 315, 360]" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col  w-full mb-4">
                    Tags
                    <treeselect v-model="tag_values" :multiple="true" :options="tags" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col  w-full mb-2">
                    Description
                    <vs-textarea  v-model="module_data.description" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col  w-full mb-2">
                    Sms alert content
                    <vs-textarea  v-model="module_data.sms_content" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col  w-full mb-2">
                    Email alert content
                    <vs-textarea  v-model="module_data.email_content" />
                </div>
            </div>
            <div class="vx-row mb-base">
                <div class="vx-col  w-full mb-2">
                    Number of student in class
                    <vs-input v-validate="'numeric|min_value:1'" class="w-full" name="number_of_students" ref="number_of_students" v-model="module_data.number_of_students" />
                    <span class="text-danger text-sm" v-show="errors.has('number_of_students')">{{ errors.first('number_of_students') }}</span>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col  w-full mb-4">
                    Lession number
                    <v-select v-validate="{regex: '^([0-9]+)$' }" name="lession_number" ref="lession_number"   taggable push-tags multiple :closeOnSelect="false" v-model="module_data.lession_number" :options="[]"/>
                    <span class="text-danger text-sm" v-show="errors.has('lession_number')">{{ errors.first('lession_number') }}</span>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mb-6">
                    <vs-checkbox class="inline-flex" v-model="moduleTypeLimited">Tick if you need unlimited number of booking</vs-checkbox>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full"  align="right">
                  <vs-button @click="validateBookingForm()" class="mr-3 mb-2">Save Module</vs-button>
                </div>
            </div>
        </vx-card>
    </div>

  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleModuleManagement from '@/store/module-management/moduleModuleManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
  // import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default{
    data() {
        return {
            module_data: {
                name : null,
                type : 'teori',
                location : null,
                hours : 45,
                name : null,
                name : null,
                number_of_students : 10,
            },
            module_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            tagId:{
                parent : [],
                child : [],
                childOfChild : []
            },
            tags : [],
            tag_values : [],
            otherModuleType_ : null,
            moduleName : null,
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
        moduleType: {
            set: function(val) {
                this.module_data.type = val.toLowerCase();
            },
            get: function() {
                let type = this.module_data.type
                return type[0].toUpperCase() + type.slice(1);
            }
        },
        otherModuleType: {
            set: function(val) {
                this.otherModuleType_ = val
            },
            get: function() {
                return this.otherModuleType_;
            }
        },
        moduleTypeLimited: {
            set: function(val) {
                this.module_data.booking_status = (val) ? 'unlimited' : 'limited';
            },
            get: function() {
                return (this.module_data.booking_status == 'unlimited') ? true : false;
            }
        },
    },
    methods: {
        storeTagId(Tags){
            let parent = []
            let child = []
            let childOfChild = []

            Tags.forEach(function(element,index){
                parent.push(element.id)

                if(Tags[index].children){
                    let children = Tags[index].children

                    children.forEach(function(elementC,indexC){
                        child.push(children[indexC].id)

                        if(Tags[index].children[indexC].children){
                            let childrenOfChild = Tags[index].children[indexC].children

                            childrenOfChild.forEach(function(elementCC,indexCC){
                                childOfChild.push(childrenOfChild[indexCC].id)
                            })
                        }
                    })
                }
            })

            this.tagId.parent = parent
            this.tagId.child = child
            this.tagId.childOfChild = childOfChild
        },
        tagIdAnalyze(tagIdList){
            let finalChild = []
            let finalParent = []
            let finalChildOfChild = []
            let oldChild = this.tagId.child
            let oldParent = this.tagId.parent
            let oldchildOfChild = this.tagId.childOfChild

            if(tagIdList){
                tagIdList.forEach(function(element,index){
                    oldParent.forEach(function(elementP,indexP){
                        if(elementP == element){
                            finalParent.push(elementP)
                        }
                    })
                    oldChild.forEach(function(elementC,indexC){
                        if(elementC == element){
                            finalChild.push(elementC)
                        }
                    })
                    oldchildOfChild.forEach(function(elementCC,indexCC){
                        if(elementCC == element){
                            finalChildOfChild.push(elementCC)
                        }
                    })
                })
            }
            return {finalParent,finalChild,finalChildOfChild};
        },
        redirectToAllModule() {
            this.$router.push("/modules").catch(() => {})
        },
        validateBookingForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.createModule()
            })
        },
        createModule() {
            this.$vs.loading({
                container: '#addModuleLoadingDiv',
                scale: 0.6
            })

            let moduleData = this.module_data
            // moduleData.tags = this.tag_values
            moduleData.other_type = this.otherModuleType_
            var {finalParent,finalChild,finalChildOfChild} = this.tagIdAnalyze(this.tag_values)

            moduleData.tags = this.tag_values
            moduleData.parent = finalParent
            moduleData.child = finalChild
            moduleData.sub_child = finalChildOfChild

            this.$store.dispatch("moduleManagement/createModule", moduleData)
            .then(res => { 
                this.$vs.loading.close('#addModuleLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                    time:4000,
                    title:'Success',
                    text: (res.data.status) ? res.data.status : 'Sussfully Updated.',
                    color:'success',
                    iconPack: 'feather',
                    icon:'icon-alert-circle'
                });

                this.$router.push("/modules/edit/" + res.data.data.id).catch(() => {})
            })
            .catch(err => {
                this.$vs.loading.close('#addModuleLoadingDiv > .con-vs-loading')
            })
        },
    },
    created() {
        if(!moduleModuleManagement.isRegistered) {
            this.$store.registerModule('moduleManagement', moduleModuleManagement)
            moduleModuleManagement.isRegistered = true
        }

        this.$store.dispatch("moduleManagement/getAllTags")
            .then(res => { 
                this.tags = res.data
                this.storeTagId(res.data)
            })
            .catch(err => {
                // console.error(err) 
            })
    },

}
</script>

